import { useCallback, useEffect, useMemo, useState } from "react";
import Tabs from "../../components/common/Tabs";
import { Container, Row, Col } from "rsuite";
import "./index.scss";
import Summary, { SummaryFilter } from "./summary";
import { customerProfitabilityConstants } from "../../utils/constants";
import MainContent from "../../components/Layouts/MainContent";
import PricingMarginWaterFall, {
	PriceMarginWaterfallFilter,
} from "./pricing-margin-waterfall";
import MainHeader from "../../components/Layouts/MainHeader";
import uparrowFilter from "../../assets/uparrowFilter.svg";
import downarrowFilter from "../../assets/downarrowFilter.svg";
import Details from "./details";
import CustomLoader from "../../components/custom-loader";
import { useLocation } from "react-router-dom";
import useFilter from "../../hooks/useFilter";

const { TABS_DATA } = customerProfitabilityConstants;

const CustomerProfitability = () => {
	const [activeTab, setActiveTab] =
		useState<CustomerProfitabilityTab>("summary");
	const [isFilterExpanded, setIsFilterExpanded] = useState<boolean>(true);
	const [baseFilterValues, setBaseFilterValues] =
		useState<BaseCustomerPortabilityFilterValues>({
			customer: "",
			district: "Minneapolis",
			project: "Project",
		});
	const { selectedFilter } = useFilter();

	const [summaryAndDetailsFilterValues, setSummaryAndDetailsFilterValues] =
		useState<any>({
			date: selectedFilter == "electrical" ? "" : [],
		});

	const [waterfallSelectedFilterValues, setWaterfallSelectedFilterValues] =
		useState<WaterFallFilterSelectedValues>({
			customer: "",
			district: undefined,
			project: "Project",
		});
	const [loader, setLoader] = useState<number>(0);

	const handleCustomerChange = useCallback((customer: string) => {
		setBaseFilterValues((prev) => ({ ...prev, customer: customer }));
	}, []);

	const handleSummaryScatterSelection = useCallback(() => {
		setActiveTab("details");
	}, []);

	const loctaionValue = useLocation();
	useEffect(() => {
		const searchedTab: any =
			new URLSearchParams(loctaionValue.search).get("active") ||
			"summary";

		if (searchedTab) {
			setActiveTab(searchedTab);
		}
	}, [loctaionValue]);
	const tabsToShow = useMemo(() => {
		if (selectedFilter == "plumbing")
			return TABS_DATA.filter(({ key }) => key != "details")
		return TABS_DATA
	}, [selectedFilter])
	return (
		<>
			<MainHeader
				customClass="relative"
				headerName="Customer Profitability"
			>
				<div className={`${isFilterExpanded ? "block" : "hidden"}`}>
					<div className="w-full">
						<div className="flex justify-start items-center gap-[1vw] pb-[2vh]">
							{activeTab === "breakDown" ? (
								<PriceMarginWaterfallFilter
									waterfallSelectedFilterValues={
										waterfallSelectedFilterValues
									}
									setLoading={setLoader}
									handleWaterfallFilterValueChange={
										setWaterfallSelectedFilterValues
									}
									handelBaseFilterValueChange={
										setBaseFilterValues
									}
									baseFilterValues={baseFilterValues}
								/>
							) : (
								<SummaryFilter
									baseFilterValues={baseFilterValues}
									handelBaseFilterValueChange={
										setBaseFilterValues
									}
									setLoading={setLoader}
									summaryAndDetailsFilterValues={
										summaryAndDetailsFilterValues
									}
									handleSummaryFilterValueChange={
										setSummaryAndDetailsFilterValues
									}
								/>
							)}
						</div>
					</div>
					<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
						<img
							className="w-[1.5vw]"
							src={uparrowFilter}
							alt="upArrow"
							onClick={() => {
								setIsFilterExpanded(false);
							}}
						/>
					</div>
				</div>
				<div
					className={` ${isFilterExpanded ? "hidden" : "flex"
						} justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer`}
				>
					<img
						className="w-[1.5vw]"
						src={downarrowFilter}
						alt="upArrow"
						onClick={() => {
							setIsFilterExpanded(true);
						}}
					/>
				</div>
			</MainHeader>

			<MainContent fullHeight={!isFilterExpanded} className="px-[2%]">
				<div className={`show-container overflow-hidden w-full`}>
					<Container className="h-full">
						<Row className="flex w-full">
							<Col xs={24} sm={24} md={8} className=" w-full">
								<Tabs
									tabsData={tabsToShow}
									activeTab={activeTab}
									setActiveTab={(
										key: CustomerProfitabilityTab
									) => setActiveTab(key)}
								/>
							</Col>
						</Row>
						<div>
							{activeTab === "summary" && (
								<Summary
									handleCustomerChange={handleCustomerChange}
									handleScatterSelection={handleSummaryScatterSelection}
									setLoading={setLoader}
									filterValues={{
										...summaryAndDetailsFilterValues,
										...baseFilterValues
									}}

									isFilterExpanded={isFilterExpanded}
								/>
							)}
							{activeTab === "breakDown" && (
								<PricingMarginWaterFall
									setLoading={setLoader}
									waterfallFilterValues={
										waterfallSelectedFilterValues
									}
									isFilterExpanded={isFilterExpanded}
								/>
							)}
							{activeTab === "details" && (
								<Details
									handleCustomerChange={handleCustomerChange}
									setLoading={setLoader}
									{...summaryAndDetailsFilterValues}
									{...baseFilterValues}
									isFilterExpanded={isFilterExpanded}
								/>
							)}
						</div>
					</Container>
				</div>
				<CustomLoader open={loader > 0} />
			</MainContent>
		</>
	);
};

export default CustomerProfitability;
